module.exports = __webpack_public_path__ + "images/emoji/diamonds.05142e67e048fa4480d3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/diamonds.png
// module id = thO9
// module chunks = 14